import React from 'react';
import Glob from "../../../libs/Glob.mjs";
import {
    Button,
    Form,
    Input,
    InputGroup,
    InputGroupText,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import EditIcon from "../../../media/images/EditIcon.mjs";
import AppOkIcon from "../../../media/app-images/AppOkIcon.mjs";
import AppSettingIcon from "../../../media/app-images/AppSettingIcon.mjs";
import appLib from "../../../libs/appLib.mjs";


const prefix = 'UserEditModal';

const UserEditModal = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = { data: structuredClone(props.user) }
        this.uid = Glob.generateUid(prefix);
    }
    render() {
        const u = this.state.data
        return(
            <Modal
                id={this.uid}
                className={prefix}
                isOpen={true}
                toggle={this.props.close}
                backdrop={"static"}
                fade={false}
                onOpened={ appLib.modalAutoFocus }
            >
                <ModalHeader toggle={this.props.close}>
                    <EditIcon />
                    { u?.username }
                </ModalHeader>
                <Form
                    autoComplete="off"
                    onSubmit={(e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        this.props.save(this.state.data);
                    } }
                >
                    <ModalBody>
                        <InputGroup>
                            <InputGroupText>
                                <Label>
                                    <TextLabel value={"Notes"} />:
                                </Label>
                            </InputGroupText>
                            <Input
                                type="textarea"
                                name="notes"
                                value={ this.state.data.notes || '' }
                                onChange={ e => {
                                    const d = this.state.data;
                                    d.notes = e.target.value;
                                    this.setState({ data: d });
                                } }
                            />
                        </InputGroup>

                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-icon"
                            onClick={this.props.close}
                        >
                            <i>
                                <AppSettingIcon />
                            </i>
                            <b>
                                <TextLabel value={"Cancel"} />
                            </b>
                        </Button>
                        <Button
                            type="submit"
                            className="btn-icon"
                            color="primary"
                            disabled={ this.props.user.notes === this.state.data.notes }
                        >
                            <b>
                                <TextLabel value={"Save"} />
                            </b>
                            <i>
                                <AppOkIcon />
                            </i>
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>
        )
    }
}

export default UserEditModal;
